export default {
  cake: {
    56: '0xa73C15620bfA79646E9A11d0D638d66588456462',
    97: '0x9F861a8aCa106A3b3A12385eAE76784885D51239',
  },
  masterChef: {
    56: '0x885785A379a93afA8A5a28397CD0e231bc749266',
    97: '0xa73C15620bfA79646E9A11d0D638d66588456462',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
  },
  usdt: {
    56 : '0x55d398326f99059fF775485246999027B3197955',
    97 : ''
  },
  // 43114 -> mainnet
  wavax : {
    43114 : '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
    43113 : '0xd00ae08403b9bbb9124bb305c09058e32c39a48c'
  },
  buzz : {
    56 : '0xa73C15620bfA79646E9A11d0D638d66588456462',
    97 : '0x9F861a8aCa106A3b3A12385eAE76784885D51239'
  },
  btcb : {
    56 : '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    97 : ''
  },
  ethb : {
    56 : '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    97 : ''
  },
  realCake : {
    56 : '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    97 : ''
  },
  banana : {
    56 : '0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95',
    97 : ''
  },
  cosmicFarm : {
    56 : '0x79eFe3cC2E2291D9570762d0a6b8Cf00B9d593df',
    97 : '0x79eFe3cC2E2291D9570762d0a6b8Cf00B9d593df'
  }
}
